const assignmentStepsWhitespace = ["Roles", "Authorities"];
const assignmentStepsHWRCRoleSuperAdmin = ["Roles"];
const assignmentStepsHWRCRoleAdminLogisticsTeam = ["Roles", "Regions"];
const assignmentStepsHWRCRoleSite = ["Roles", "Regions", "Sites"];
export {
  assignmentStepsWhitespace, assignmentStepsHWRCRoleSuperAdmin, assignmentStepsHWRCRoleAdminLogisticsTeam, assignmentStepsHWRCRoleSite
};
